<template>
  <div id="Maintenance" class="h-full sun">
    <div class="image">
      <img src="@/assets/images/error/maintenance.png" alt="repair" />
    </div>
    <div class="title">
      점검 중입니다.
    </div>
    <div class="content">
      <b>최대 1시간</b>내로 정상 운영할 예정입니다.<br/>
      사이트 이용에 불편을 드려 죄송합니다.
    </div>
  </div>
</template>

<script>
export default {
  chimera: {
    ping() { return { url: 'ping' } },
  },
  async created() {
    try {
      await this.ping.fetch()
      this.$router.push({ name: 'main' })
    } catch (e) {
      console.log(e)
    }
  }
}
</script>

<style lang="scss" scoped>
  #Maintenance {
    width: 100%;
    .image {
      width: 100%;
      display: flex;
      align-content: center;
      justify-content: center;
      margin-top: calc(128vh / 647 * 100);
      img {
        width: auto;
        height: calc(176vh / 647 * 100);
      }
    }
    .title {
      width: 100%;
      font-weight: 900;
      font-size: 28px;
      text-align: center;
      color: #333333;
      margin-top: calc(18vh / 647 * 100);
    }
    .content {
      width: 100%;
      font-size: 16px;
      line-height: 1.5;
      text-align: center;
      color: #727d8c;
      margin-top: calc(16vh / 647 * 100);
    }
  }
</style>
